import { Provider } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import "./App.scss";
import { MapContextProvider } from "./context/mapContext";
import { store } from "./features/store";
import Rutas from "./routes/Rutas";

export default function App() {
  return (
    <Provider store={store}>
      <MapContextProvider>
        <Rutas />
      </MapContextProvider>
    </Provider >
  );
}
